( function($) {
	function get_lat_lng( e, el ) {
		e.preventDefault();

		// disable load more button for accidental double clicks
		el.prop( 'disabled', true );

		// Hide error
		$( "#submissionError" ).addClass( 'uk-hidden' );

		// Pass in any necessary attributes
		var button = el;
		var	data = {
			action: el.attr( "action" ),
			address: document.getElementById( 'locationValue' ).value,
			site: "", // value required for multisites
		};

		// Get the button text so it can reset
		var buttonText = el.text();

		$.ajax( {
			url: data.site + "/wp-admin/admin-ajax.php", // AJAX handler
			data: data,
			type: "POST",

			beforeSend: function () {
				// if( document.documentElement.lang.includes( 'fr' ) ) {
				// 	button.text( 'Chargement...' ); // change the button text
				// }

				// else {
					button.text( 'Searching...' ); // change the button text
				// }
			},

			success: function( html ) {
				// re-enable the load more button
				el.prop( 'disabled', false );

				if( html ) {					
					var coord = JSON.parse( html );

					var lat 	= coord.lat;
					var lng	  = coord.lng;
					var query = document.getElementById( 'locationValue' ).value;

					if( lat && lng ) {
						button.text( 'Found!' );
						
						window.location.href = window.location.origin + '/locations/?lat=' + lat + '&lng=' + lng + '&query=' + query;
					}

					// geocode didn't return any lat/lng
					else {
						button.text( buttonText );

						$( "#submissionError" ).removeClass( 'uk-hidden' );
					}
				}
				
				else {
					console.log( 'something went wrong' );
				}
			},
		} );
	}

	$( '.find-btn' ).on( 'click', function(e) {		
		get_lat_lng( e, $( this ) );
	} );
} )( jQuery );